import { h } from 'preact'
import { IMatchesByDay } from '../../lib/model'
import styles from './MatchesSection.module.css'
import { MatchResult } from '../MatchResult/MatchResult'
import { MatchStatus } from '../MatchStatus/MatchStatus'
import { MatchTeams } from '../MatchTeams/MatchTeams'
import { useEffect, useState } from 'preact/hooks'
import {
  findNearestGameIndex,
  findNearestTournamentDay,
  formatMatchDate,
  isNearestTournamentDay,
  sortMatches,
  statusLabel,
} from './match-section-utils'

interface Props {
  matches: IMatchesByDay
}

export function MatchesSection(props: Props) {
  const [todayElement, setTodayElement] = useState<HTMLTimeElement | null>(null)
  const [coreScrollElement, setCoreScrollElement] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    if (todayElement) {
      coreScrollElement?.scroll(todayElement.offsetLeft, 0)
    }
  }, [coreScrollElement, todayElement])

  return (
    <div class={styles['dh-fotball-banner__matchesSection']}>
      <div
        ref={setCoreScrollElement}
        class={styles['dh-fotball-banner__scrollItemsWrapper']}
        id={'scroll'}
      >
        {collectElementsList(props.matches, setTodayElement)}
      </div>
    </div>
  )
}

export function collectElementsList(matches: IMatchesByDay, setTodayElement) {
  const nearestTournamentDay = findNearestTournamentDay(matches)

  const elementsList = []
  Object.keys(matches).forEach((matchDay) => {
    const isNearestDay = isNearestTournamentDay(matchDay, nearestTournamentDay)
    const timeElement = (
      <time dateTime={matchDay} class={`${styles['dh-fotball-banner__matches-date']}`}>
        {formatMatchDate(matchDay)}
      </time>
    )
    elementsList.push(timeElement)

    const sorted = sortMatches(matches[matchDay])
    const nearestGameIndex = isNearestDay ? findNearestGameIndex(sorted) : -1

    sorted.forEach((matchData, index) => {
      const status = statusLabel(matchData.matchStatusId)
      const matchElement =
        nearestGameIndex === index ? (
          <div
            ref={setTodayElement}
            class={
              status === 'Pågår'
                ? styles['dh-fotball-banner__match-details-ongoing']
                : styles['dh-fotball-banner__match-details']
            }
          >
            <MatchStatus matchData={matchData} statusLabel={status} />
            <MatchResult result={matchData.result} statusLabel={status} />
            <MatchTeams matchData={matchData} />
          </div>
        ) : (
          <div
            class={
              status === 'Pågår'
                ? styles['dh-fotball-banner__match-details-ongoing']
                : styles['dh-fotball-banner__match-details']
            }
          >
            <MatchStatus matchData={matchData} statusLabel={status} />
            <MatchResult result={matchData.result} statusLabel={status} />
            <MatchTeams matchData={matchData} />
          </div>
        )
      elementsList.push(matchElement)
    })
  })

  return elementsList
}
